import { IonButton, IonImg } from '@ionic/react';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

interface Props {
  imgSource: any;
  msg: string;
  refetch?: () => void;
}

export const DataPlaceholder = ({ imgSource, msg, refetch }: Props) => {
  const { t } = useTranslation();

  const getRefetch = useCallback(() => {
    if (refetch) {
      return (
        <div className="margin-t-40">
          <IonButton mode="md" onClick={refetch} fill="outline" className="ion-info-button">
            {t('SHARED.RETRY_REQUEST')}
          </IonButton>
        </div>
      );
    }
  }, [refetch, t]);

  return (
    <div className="flex-center-center-column-nowrap margin-t-80">
      <div style={{ width: '320px', height: '240px' }}>
        <IonImg src={imgSource} className="ionImageNoBorder" />
      </div>
      <div className="mediumText5 margin-t-40 text-center" style={{ whiteSpace: 'pre-line' }}>{t(msg)}</div>
      {getRefetch()}
    </div>
  );
};
